// 统一请求路径前缀在libs/axios.js中修改
import { getRequest, postRequest,postJsonRequest, putRequest,postRequestimg,putJsonRequest, deleteRequest, getRequestWithNoToken,downLoadFileRequest } from '@/libs/axios';



// 文件上传接口
export const uploadFile = "/manage/upload/file"

//中小企业信息查询
export const getfrimmsg = (params) => {
    return getRequest('dctapp/hb/cegn/openApi/kjbkjxzxqyrkdjxxjkcx/v1', params)
}


//创文助手，确认是否有权限
export const getjurisdiction = (params) => {
    return getRequest('dctapp/cwzsAccessUser/findByMobile', params)
}
// 创文助手,用户插入创文用户表
export const addchuangwenuser = (params) => {
    return postRequest('dctapp/cwzsUser', params)
}
// 创文助手,行为类别，根据字典类型获取字典值的下拉列表
export const getDictValList = (params) => {
    return getRequest('dctapp/cwzsDicValue/htmlSelect', params)
}
// 创文助手 提交处理
export const addReport = (params) => {
    return postRequest('dctapp/cwzsReport', params)
}
//创文  图片上传 
export const uploadFilechuangwen = (params) => {
    return postRequestimg('dctapp/cwzsFileTransfer/upload', params)
}
// 获取创文助手用户数据
export const getCwUser = (params) => {
    return getRequest('dctapp/cwzsUser', params)
}
// 查询历史处理记录
export const wzList = (params) => {
    return postRequest('dctapp/cwzsReport/getHandleList', params)
}
// 根据用户id来获取用户数据
export const getCwUserById = (params) => {
    return getRequest('dctapp/cwzsUser/findById', params)
}
// 查询当前id对应的记录
export const getCurRes = (params) => {
    return postRequest('dctapp/cwzsReport/getHandle', params)
}
// 根基idcard查询历史数据
export const getHandleListByIDcard = (params) => {
    return postRequest('dctapp/cwzsReport/getHandleListByIDcard', params)
}
// 警察处理report数据
export const handleReport = (params) => {
    return postRequest('dctapp/cwzsReport/handle', params)
}

//根据用户获取 卡口统计权限
export const getCascade = (params) => {
    return getRequest('dctapp/district/cascade', params)
}

//根据用户获取 卡口统计权限
export const getKakouFindById = (params) => {
    return getRequest('dctapp/kakou/findById', params)
}

//身份证号解密
export const decodeField = (params) => {
    return postRequest('dctapp/encryption/decode', params)
}

//通过身份证号获取用户信息
export const findUserByIdCard = (params) => {
    return getRequest('dctapp/user/findByIdcard', params)
}

//根据卡口ID获取卡口
export const finddoorbuyId = (params) => {
    return getRequest('dctapp/door/finddoorbuyId', params)
}

// 通过药品条码信息获取药品数据
export const findOneYpByCode = (params) => {
    return getRequest('dctapp/medicine/findByCode', params)
}

// 通过药品条码信息获取(阿里云药品查询)药品数据
export const findOneYpByBarcode = (params) => {
    return getRequest('dctapp/medicineControl/getAliYp', params)
}

// 药品修改 扫码新增
export const medicineEidt = (params) => {
    return postRequest('dctapp/medicine/updateBycode', params)
}
// 药品新增 输入新增
export const medicineAdd = (params) => {
    return postRequest('dctapp/medicine', params)
}

//四类药处方 图片上传 
export const sileiyaoupload = (params) => {
    return postRequestimg('dctapp/upload', params)
}

//四类药处方  第三部 提交export const medicineControl = (params) => {    return postRequest('dctapp/medicineControl', params)}
// 一业一码
export const findOneEnt = (params) => {    return getRequest('dctapp/yyyzEntInfo/getBySocialCode', params)}


// 人才小程序登录
export const rcuserRclogin = (params) => {    return getRequest('dctapp/rcuser/rclogin', params)}
//mobile

// 通过用户id获取是否企业信息创建人
export const getComapnyByuser = (params) => {    return getRequest('dctapp/company/getComapnyByuser', params)}
//user_id



// 获取公司信息
export const companyinfo = (params) => {    return getRequest('dctapp/company/companyinfo', params)}
//id



//小程序信息统计
export const getMiniappCount = (params) => {    return getRequest('dctapp/statistical/getMiniappCount', params)}

//手机号模糊搜索
export const findUserById = (params) => {    return getRequest('dctapp/user/findById', params)}
//id
